import { ProcedureStepFieldValuesReviewType } from "@overmap-ai/common"

import { FilterModifier } from "./FilterModifier"

export const ProcedureStepReviewStatusEqualsFilterModifier = FilterModifier.create<
	ProcedureStepFieldValuesReviewType | null,
	ProcedureStepFieldValuesReviewType | null
>({
	id: "procedure-step-review-status-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepReviewStatusNotEqualsFilterModifier = FilterModifier.create<
	ProcedureStepFieldValuesReviewType | null,
	ProcedureStepFieldValuesReviewType | null
>({
	id: "procedure-step-review-status-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepReviewStatusIncludesFilterModifier = FilterModifier.create<
	ProcedureStepFieldValuesReviewType | null,
	(ProcedureStepFieldValuesReviewType | null)[]
>({
	id: "procedure-step-review-status-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const ProcedureStepReviewStatusExcludesFilterModifier = FilterModifier.create<
	ProcedureStepFieldValuesReviewType | null,
	(ProcedureStepFieldValuesReviewType | null)[]
>({
	id: "procedure-step-review-status-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
